<template>
  <div id="app">
    <div id="app-layout">

      <div id="BarraSuperior" aria-label="Barra_Superior">
        <BarraSuperior/>
      </div>

      <div id="Filtres" aria-label="Filtres">
        <Filtres/>
      </div>

      <div id="Graph" aria-label="Graf">
        <Graph/>
      </div>

    </div>

    <!-- A partir d'aquí les coses que estàn posicionades de forma absoluta -->

    <div id="Cercador" aria-label="Cercador">
      <SearchBar/>
    </div>

    <nav id="Info_node" aria-label="Info_Node" v-if="this.display_info">
      <Info/>
    </nav>

    <nav id="Info_cluster" aria-label="Info_cluster" v-if="this.display_infoCluster" :style="this.display_info ? 'right: calc(14% + 16px);' : 'right: 2px;'">
      <InfoCluster/>
    </nav>

    <nav id="Info_zona" aria-label="Info_zona" v-if="this.display_info_zona">
      <InfoZona/>
    </nav>

    <div id ="loader" v-if="this.display_loader" >
      <div id= "background-spinner">
        <self-building-square-spinner id ="spinner" :animation-duration="6000" :size="40" color="#0077C8"/>
      </div>
    </div>
  </div>
</template>

<script>
import BarraSuperior from './components/BarraSuperior.vue';
import Graph from './components/Graph.vue';
import Filtres from './components/Filtres.vue';
import SearchBar from './components/SearchBar.vue';
import Info from './components/Info.vue';
import InfoCluster from './components/InfoCluster.vue';
import SelfBuildingSquareSpinner from './components/SelfBuildingSquareSpinner.vue';
import InfoZona from './components/InfoZona.vue';


export default {
  name: 'App',
  components: {
    BarraSuperior,
    Filtres,
    SearchBar,
    Info,
    InfoCluster,
    Graph,
    SelfBuildingSquareSpinner,
    InfoZona
  },
  data(){
    return{
    }
  },
   computed: {
    display_info() {
      return this.$store.getters.display_info;
    },
    display_infoCluster() {
      return this.$store.getters.display_cluster;
    },
    display_loader() {
      return this.$store.getters.loader;
    },
    display_info_zona() {
      return this.$store.getters.display_zona;
    }
  },
};
</script>

<style>
  @import './assets/styles/variables.css';

  #app{
    display: inline;
    color: #333;
    font-size: 14px;
    font-family: 'Lato', sans-serif;
  }

  #app-layout {
    position: relative;
    display: grid;
    grid-template-columns: 16.5% 83.5%;
    grid-template-rows: 56px calc(100% - 56px);
    width: 100vw;
    height: 100vh;
    background: white;
  }

  #BarraSuperior {
    grid-column-start: 1;
    grid-column-end: 3;
    background: white;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  #Filtres {
    width: 100%;
    height: 100%;
  }

  #Graph{
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  #Cercador {
    position: absolute;
    left: calc(16.5%);
    top: 56px;
    width: 25%;
    background: transparent;
    padding: 10px;
  }

  #Info_node {
    position: absolute;
    width: 14%;
    height: calc(100% - 88px);
    top: 58px;
    right: 2px;
    background: rgb(255, 255, 255);
    border: 1px solid black;
    padding: 10px 2px 10px 10px;
    overflow-y: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    clip-path: inset(0px 0px -6px -6px);
  }

  #Info_cluster {
    position: absolute;
    width: 20%;
    height: calc(100% - 88px);
    top: 58px;
    background: rgb(255, 255, 255);
    border: 1px solid black;
    padding: 10px 2px 10px 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    clip-path: inset(0px 0px -6px -6px);
  }

  #Info_zona {
    position: absolute;
    width: 20%;
    height: calc(100% - 88px);
    top: 58px;
    right: 2px;
    background: rgb(255, 255, 255);
    border: 1px solid black;
    padding: 10px 2px 10px 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    clip-path: inset(0px 0px -6px -6px);
  }

  #background-spinner{    
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.6);
    display: block;
    width: 100vw;
    height: 100vh;
    z-index: 999;
  }
  #spinner{
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
  }
  html, body {
    overflow-x: hidden;
    overflow-y: hidden;
    margin: 0;
    padding: 0;
  }
</style>
